const RewardSources: any = {
  FI: 'FI',
  // GRANT_DOLLARS: 'Grant Dollars'
};

export default RewardSources;
